//burasinin otomatik olusturulmasi lazim ama entity tablolarin hepsi geliyor????

import { FormYetkiDto } from "@dabnet-kamu/libs/ui";


export interface IReturn<T>
{
    createResponse(): T;
}

export class BaseRequest<E>
{

    public constructor(init?: Partial<BaseRequest<E>>) { (Object as any).assign(this, init); }
}

export class GasDosyaIndirDto
{
    public documentId: number;
    public documentContent: string;
    public documentName :string;
    public constructor(init?: Partial<GasDosyaIndirDto>) { (Object as any).assign(this, init); }
}

export class BaseResponse
{
    public result: boolean;
    public errorCode: string;
    public errorMessage: string;
    public errors: string[];
    public warnings: string[];
    public errorDetails: string[];
    public totalPages: number;
    public totalCount: number;
    public pageSize: number;

    public constructor(init?: Partial<BaseResponse>) { (Object as any).assign(this, init); }
}

export class GasDosyaIndirZip_Response extends BaseResponse
{
    public downloadableDocuments: GasDosyaIndirDto[];

    public constructor(init?: Partial<GasDosyaIndirZip_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GasDosyaIndirZip_Request extends BaseRequest<GasDosyaIndirZip_Response> implements IReturn<GasDosyaIndirZip_Response>
{
    public dosyaKod: number;
    public belgeTuruKod: number;
    /** Dolu ise belge türü yerine SDP koduna göre indirir (bu kod ve altındaki kodlar). */
    public dosyaPlanKod?: string;

    public constructor(init?: Partial<GasDosyaIndirZip_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GasDosyaIndirZip_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GasDosyaIndirZip_Response(); }
}



export class GasDosyaKapat_Response extends BaseResponse
{

    public constructor(init?: Partial<GasDosyaKapat_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GasDosyaKapat_Request extends BaseRequest<GasDosyaKapat_Response> implements IReturn<GasDosyaKapat_Response>
{
    public eskiDosyaKod: number;
    public yeniDosyaKod: number;

    public constructor(init?: Partial<GasDosyaKapat_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GasDosyaKapat_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GasDosyaKapat_Response(); }
}

 
export class GasSeciliBelgeSil_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public dosyaKod: number;
    public belgeKodlari: number[];

    public constructor(init?: Partial<GasSeciliBelgeSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GasSeciliBelgeSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}
export class GasDosyaTalep_Request extends BaseRequest<GasDosyaKapat_Response> implements IReturn<GasDosyaKapat_Response>
{
    public piArsivDosyaKod: number;
    public piPersonelKod: number;
    public piBirimKod: number;
    public piTalepTarih: string;
    public piEvrakTarih: string;
    public piEvrakNo: number;
    public piAciklama: string;

    public constructor(init?: Partial<GasDosyaTalep_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GasDosyaTalep_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GasDosyaKapat_Response(); }



}


export class GasTopluSil_Request extends BaseRequest<BaseResponse> implements IReturn<BaseResponse>
{
    public ustKod: number;
    public dosyaKod: number;
    public belgeTuruKod: number;

    public constructor(init?: Partial<GasTopluSil_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GasTopluSil_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaseResponse(); }
}



export class GasDosyaBelgeKaydet_Response extends BaseResponse
{
    public documentId: number;
    public documentName: string;

    public constructor(init?: Partial<GasDosyaBelgeKaydet_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GasDosyaBelgeKaydet_Request extends BaseRequest<GasDosyaBelgeKaydet_Response> implements IReturn<GasDosyaBelgeKaydet_Response>
{
    public gasDosyaBelgeKod: number;
    public documentContent: string;
    public documentName: string;
    public documentPath: string;

    public constructor(init?: Partial<GasDosyaBelgeKaydet_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GasDosyaBelgeKaydet_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GasDosyaBelgeKaydet_Response(); }
}


export class GASGetDocumentContent_Response extends BaseResponse
{
    public dysKod: number;
    public dysContent: string;
    public dysPath?: string;
    public dysName: string;
    public dysType: string;

    public constructor(init?: Partial<GASGetDocumentContent_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/GAS/GetDocumentContent")
export class GASGetDocumentContent_Request extends BaseRequest<GASGetDocumentContent_Response> implements IReturn<GASGetDocumentContent_Response>
{
    public gasDosyaBelgeKod: number;
    public dysId: number;

    public constructor(init?: Partial<GASGetDocumentContent_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GASGetDocumentContent_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GASGetDocumentContent_Response(); }
}

export class GAS_Get_ArsivKod_Response extends BaseResponse
{
    public dosyaKod: number;
    public dosyaTuru: string;

    public constructor(init?: Partial<GAS_Get_ArsivKod_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/GAS/Get_ArsivKod")
export class GAS_Get_ArsivKod_Request extends BaseRequest<GAS_Get_ArsivKod_Response> implements IReturn<GAS_Get_ArsivKod_Response>
{
    public kaynak: string;
    public kaynakKod: number;

    public constructor(init?: Partial<GAS_Get_ArsivKod_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GAS_Get_ArsivKod_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GAS_Get_ArsivKod_Response(); }
}


export class GasKullaniciYetki_Response extends BaseResponse
{
    public kullaniciYetki: FormYetkiDto;

    public constructor(init?: Partial<GasKullaniciYetki_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/GAS/GasKullaniciYetki")
export class GasKullaniciYetki_Request extends BaseRequest<GasKullaniciYetki_Response> implements IReturn<GasKullaniciYetki_Response>
{
    public birimKod: number;
    public dosyaKod: number;

    public constructor(init?: Partial<GasKullaniciYetki_Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GasKullaniciYetki_Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GasKullaniciYetki_Response(); }
}